import { KEY_NAME } from '@nexxt/common/constants';
import * as React from 'react';
import { Transformer } from 'react-konva';

interface TransformerProps {
    selectedShapeName: any;
}
const TransformerContainer: React.FC<TransformerProps> = (props) => {
    let transformer = React.useRef() as Transformer;
    const [enableKeepRatio, setEnableKeepRatio] = React.useState(false);
    React.useEffect(() => {
        if (props.selectedShapeName) {
            checkNode();
        }
    });

    React.useEffect(() => {
        // add event listeners so users can enable scaling transformation with shift key
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyUp);
        };
    }, []);

    const handleKeyDown = (e) => {
        if (e.key === KEY_NAME.SHIFT) {
            setEnableKeepRatio(true);
        }
    };
    const handleKeyUp = (e) => {
        if (e.key === KEY_NAME.SHIFT) {
            setEnableKeepRatio(false);
        }
    };

    const checkNode = () => {
        // here we need to manually attach or detach Transformer node
        const stage = transformer['current'].getStage();
        const { selectedShapeName } = props;
        let selectedNode = stage.findOne('.' + selectedShapeName);
        // do nothing if selected node is already attached
        if (selectedNode === transformer['current'].node()) {
            return;
        }
        if (selectedNode) {
            const type = selectedNode.getType();
            const ShapeType = selectedNode.attrs.name.split('-')[1];
            if (type === 'Shape' && ShapeType === 'text') {
                return;
            }
            if (type !== 'Group') {
                selectedNode = selectedNode.findAncestor('Group');
            }
            // attach to another node
            transformer['current'].nodes([selectedNode]);
        } else {
            // remove transformer
            transformer['current'].detach();
        }
        transformer['current'].getLayer().batchDraw();
    };
    const onTransformStart = () => {
        console.log('onTransformStart');
    };

    const onTransform = () => {
        console.log('onTransform');
    };

    const onTransformEnd = () => {
        console.log('end transform');
    };

    return (
        <Transformer
            ref={transformer as any}
            transformstart={onTransformStart}
            transform={onTransform}
            transformend={onTransformEnd}
            rotateEnabled={true}
            rotationSnaps={[0, 45, 90, 135, 180, 225, 270, 315, 360]}
            keepRatio={enableKeepRatio}
        />
    );
};

export default TransformerContainer;
